(function (window) {
  'use strict';

  var Gwp = window.XtresseGwp || (window.XtresseGwp = {});
  var BOUND = 'data-gwp-cta-bound';

  if (!Array.isArray(Gwp._busyButtons)) Gwp._busyButtons = [];

  function resetButton(button, label) {
    if (!button) return;
    if (label) button.textContent = label;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }

  function setButtonBusy(button) {
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (Gwp._busyButtons.indexOf(button) === -1) Gwp._busyButtons.push(button);
  }

  Gwp.addSubscriptionToCart = function (opts) {
    var variantId = Gwp.normalizeId(opts && opts.variantId);
    var sellingPlanId = Gwp.normalizeId(opts && opts.sellingPlanId);
    var quantity = Number(opts && opts.quantity);
    var button = opts && opts.button;

    if (!variantId || !sellingPlanId || !quantity) {
      console.warn('GWP CTA: missing cart payload');
      return Promise.reject(new Error('missing cart payload'));
    }

    if (button && (button.disabled || button.getAttribute('aria-busy') === 'true')) {
      return Promise.resolve();
    }
    setButtonBusy(button);

    if (Gwp._cartOperation) return Gwp._cartOperation;

    Gwp._cartOperation = Gwp.fetchCartJson()
      .then(function (cart) {
        if (Gwp.cartHasSubscription(cart, variantId, sellingPlanId)) {
          window.location.href = Gwp.cartPageUrl();
          return null;
        }

        return fetch(Gwp.cartAddUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: quantity,
                selling_plan: Number(sellingPlanId),
              },
            ],
          }),
        }).then(function (response) {
          return Gwp.readJsonResponse(response, 'cart add failed');
        });
      })
      .then(function (data) {
        if (!data) return;

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          try {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'gwp-offer',
              productVariantId: Number(variantId),
              cartData: data,
            });
          } catch (e) {}
        }

        window.location.href = Gwp.cartPageUrl();
      })
      .catch(function (err) {
        Gwp._busyButtons.forEach(function (busyButton) {
          resetButton(busyButton, 'Try again');
        });
        throw err;
      })
      .finally(function () {
        Gwp._cartOperation = null;
        Gwp._busyButtons = [];
      });

    return Gwp._cartOperation;
  };

  Gwp.addSubscriptionAndCheckout = Gwp.addSubscriptionToCart;

  function onCtaClick(event) {
    var btn = event.currentTarget;
    Gwp.addSubscriptionToCart({
      variantId: btn.getAttribute('data-gwp-variant-id'),
      sellingPlanId: btn.getAttribute('data-gwp-selling-plan-id'),
      quantity: btn.getAttribute('data-gwp-quantity'),
      button: btn,
    }).catch(function () {});
  }

  Gwp.bindCtaButtons = function (root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-gwp-banner-cta]');

    buttons.forEach(function (btn) {
      if (btn.getAttribute(BOUND) === 'true') return;
      btn.setAttribute(BOUND, 'true');
      btn.addEventListener('click', onCtaClick);
    });
  };

  function autoBind() {
    Gwp.bindCtaButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoBind);
  } else {
    autoBind();
  }

  document.addEventListener('shopify:section:load', function (event) {
    Gwp.bindCtaButtons((event && event.target) || document);
  });
})(window);
